( function( $ ){

	const update_menu = () => {
		if( $( '#site-header' ).hasClass( 'supports_transparent' ) ){
			if( $( window ).scrollTop() > 1 ){
				$( '#site-header' ).addClass( 'opaque' );
			}
			else{
				$( '#site-header' ).removeClass( 'opaque' );
			}
		}
		if( $( window ).scrollTop() > 1 ){
			$( '#site-header' ).addClass( 'shadowed' );
		}
		else{
			$( '#site-header' ).removeClass( 'shadowed' );
		}
	}

	$( window ).on( 'scroll', update_menu );
	update_menu();

	$( '#mobile-menu-toggle' ).on( 'click', () => {
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.desktop-menu' ).toggleClass( 'active' );
		$( '#site-header' ).toggleClass( 'menu-open' );
		$( '#mobile-menu-toggle' ).toggleClass( 'menu-open' );
	});

	$( '#locations-menu-trigger' ).on( 'click', function(){
		$( '.locations-dropdown' ).slideToggle();
	});
	$( 'li.menu-item-has-children' ).on( 'click', function(){
		$( this ).find( 'ul.sub-menu' ).slideToggle();
	});
	$( 'li.wpml-ls-item-legacy-dropdown' ).on( 'click', function(){
		$( this ).find( 'ul.wpml-ls-sub-menu' ).slideToggle();
	});

})( jQuery );
